import { AttachFileIcon, ChevronRightIcon } from "designSystem/components/icon/index";
import { FlexColumn, FlexRowCenter, Switch, Text } from "designSystem/index";
import React, { useState } from "react";

export default () => {
	const [flipped, setFlipped] = useState(false);

	return (
		<FlexColumn>
			<FlexRowCenter gap={1} justifyContent="flex-end">
				<Text bold text={flipped ? "RTL" : "LTR"} />
				<Switch checked={flipped} onClick={() => setFlipped(!flipped)} />
			</FlexRowCenter>
			<FlexColumn dir={flipped ? "rtl" : ""}>
				<FlexRowCenter justifyContent="flex-start">
					<ChevronRightIcon />
					<Text text="Icon will flip" />
				</FlexRowCenter>
				<FlexRowCenter justifyContent="flex-start">
					<AttachFileIcon />
					<Text text="Icon will not flip" />
				</FlexRowCenter>
			</FlexColumn>
		</FlexColumn>
	);
};